import { render, staticRenderFns } from "./storeDictionaryList.vue?vue&type=template&id=15b74752&scoped=true&"
import script from "./storeDictionaryList.vue?vue&type=script&lang=js&"
export * from "./storeDictionaryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b74752",
  null
  
)

component.options.__file = "storeDictionaryList.vue"
export default component.exports